angular.module("Main").directive("surveyWizard", wizzard);

function wizzard() {
    return {
        templateUrl: "./app/Main/controls/bookingWizardAlt/surveyWizard.html",
        restrict: "EA",
        controller: SurveyWizardController,
        controllerAs: "vm",
        scope: true,
        link: function (scope, element, attrs) {
            scope.active = scope.$eval(attrs.active);
            scope.cid = scope.$eval(attrs.cid);
        }
    };
}

SurveyWizardController.$inject = ["$scope", "$stateParams", "$state", "SessionService"];

function SurveyWizardController($scope, $stateParams, $state, SessionService) {
    var vm = this;

    vm.goto = function () {
        $state.go("surveys", {sid: SessionService.getSessionId(), cid: $scope.cid});
    }
}